import { Module } from 'vuex';
import {
	RootState,
	ContactState,
	ContactEditableItem,
	GroupedContactProfiles,
	SearchMergeContactBy,
	ContactProfileGroup,
	AllPartnersUnitMap,
} from '../types';
import {
	Contact,
	ContactProfile,
	FamilyRelation,
	Center,
	ContactTypeCode,
	ProfileType,
	ContactProfileDto,
	ProfileTypeCategoryCode,
	RelationCode,
	ContactDto,
	Plan,
	TableItemsOptions,
	FamilyApplicantType,
	SubgroupedContactProfiles,
	ContactSearchCondition,
} from '../../types';
import { api } from '../../plugins/salut-api';
import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';

import { contactApi } from '../../lib/salut-api/contact';

const SET_CONTACT = 'SET_CONTACT';
const SET_CONTACTS = 'SET_CONTACTS';
const SET_SELECTED_CONTACTS = 'SET_SELECTED_CONTACTS';
const SET_CURRENT_CONTACT_PROFILE = 'SET_CURRENT_CONTACT_PROFILE';
const SET_CURRENT_MEMBERSHIP_APPLICATION = 'SET_CURRENT_MEMBERSHIP_APPLICATION';
const SET_DRAFT_CONTACT_PROFILE_STATUS = 'SET_DRAFT_CONTACT_PROFILE_STATUS';
const SET_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS =
	'SET_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS';
const SET_PROFILE_CENTERS = 'SET_PROFILE_CENTERS';
const SET_PROFILE_USERS = 'SET_PROFILE_USERS';
const ADD_PENDING_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS =
	'ADD_PENDING_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS';
const POP_PENDING_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS =
	'POP_PENDING_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS';
const SET_EDITING = 'SET_EDITING';
const SET_FAMILY_RELATIONS = 'SET_FAMILY_RELATIONS';
const SET_FAMILY_RELATIONS_BY_CONTACT = 'SET_FAMILY_RELATIONS_BY_CONTACT';
const SET_CURRENT_CENTER = 'SET_CURRENT_CENTER';
const SET_PROFILE_TYPES = 'SET_PROFILE_TYPES';
const SET_PROFILE_TYPES_BY_CONTACT_TYPE = 'SET_PROFILE_TYPES_BY_CONTACT_TYPE';
const SET_CURRENT_CONTACT_TYPE = 'SET_CURRENT_CONTACT_TYPE';
const SET_CURRENT_PROFILE_TYPE = 'SET_CURRENT_PROFILE_TYPE';
const SET_FAMILY_MEMBER_PROFILES = 'SET_FAMILY_MEMBER_PROFILES';
const SET_ALL_FAMILY_PROFILES_ALL_MEMBER_PROFILES =
	'SET_ALL_FAMILY_PROFILES_ALL_MEMBER_PROFILES';
const SET_DUPLICATE_CONTACT_CHECKING_CONTACTS =
	'SET_DUPLICATE_CONTACT_CHECKING_CONTACTS';
const SET_DUPLICATE_CONTACT_CHECKING_CRITERIA =
	'SET_DUPLICATE_CONTACT_CHECKING_CRITERIA';
const SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CONTACTS =
	'SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CONTACTS';
const SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CRITERIA =
	'SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CRITERIA';
const UNSET_DUPLICATE_FAMILY_CONTACT_CHECKING =
	'UNSET_DUPLICATE_FAMILY_CONTACT_CHECKING';
const SET_DRAFT_CONTACT = 'SET_DRAFT_CONTACT';
const SET_DRAFT_FAMILY_MEMBER_BY_KEY = 'SET_DRAFT_FAMILY_MEMBER_BY_KEY';
const UNSET_DRAFT_FAMILY_MEMBER_BY_KEY = 'UNSET_DRAFT_FAMILY_MEMBER_BY_KEY';
const UNSET_DRAFT_FAMILY_MEMBERS = 'UNSET_DRAFT_FAMILY_MEMBERS';
const SET_DRAFT_FAMILY_CONTACT_BY_INDEX = 'SET_DRAFT_FAMILY_CONTACT_BY_INDEX';
const SET_DRAFT_FAMILY_CONTACT_PROFILE_BY_INDEX =
	'SET_DRAFT_FAMILY_CONTACT_PROFILE_BY_INDEX';
const ADD_DRAFT_FAMILY_CONTACT = 'ADD_DRAFT_FAMILY_CONTACT';
const UNSET_DRAFT_FAMILY_CONTACT_BY_INDEX =
	'UNSET_DRAFT_FAMILY_CONTACT_BY_INDEX';
const UNSET_DRAFT_FAMILY_CONTACTS = 'UNSET_DRAFT_FAMILY_CONTACTS';
const SET_APPS_FOR_CONTACTS = 'SET_APPS_FOR_CONTACTS';
const SET_MEMBERS_PAGE_DATA = 'SET_MEMBERS_PAGE_DATA';
const SET_VOLUNTEERS_PAGE_DATA = 'SET_VOLUNTEERS_PAGE_DATA';
const SET_PARTICIPANTS_PAGE_DATA = 'SET_PARTICIPANTS_PAGE_DATA';
const SET_JOB_PARTICIPANTS_PAGE_DATA = 'SET_JOB_PARTICIPANTS_PAGE_DATA';
const SET_ALL_CONTACTS_PAGE_DATA = 'SET_ALL_CONTACTS_PAGE_DATA';
const SET_APPLICATIONS_PAGE_DATA = 'SET_APPLICATIONS_PAGE_DATA';
const SET_MERGE_CONTACTS_PAGE_DATA = 'SET_MERGE_CONTACTS_PAGE_DATA';
const SET_PARTNER_TABLE_PAGE_DATA = 'SET_PARTNER_TABLE_PAGE_DATA';
const SET_ALL_PARTNERS = 'SET_ALL_PARTNERS';
const SET_ALL_PARTNERS_UNIT_MAP = 'SET_ALL_PARTNERS_UNIT_MAP';
const SET_CONTACT_SEARCH_RESULT = 'SET_CONTACT_SEARCH_RESULT';
const SHOW_LOADING = 'SHOW_LOADING';
const HIDE_LOADING = 'HIDE_LOADING';
const SET_CONTACT_PAYMENT_STATUSES = 'SET_CONTACT_PAYMENT_STATUSES';
const SET_CONTACT_CASE_NOTES = 'SET_CONTACT_CASE_NOTES';
const SET_SEARCH_MERGE_CONTACT_BY = 'SET_SEARCH_MERGE_CONTACT_BY';
const SET_SEARCH_MERGE_CONTACT_INPUT = 'SET_SEARCH_MERGE_CONTACT_INPUT';
const SET_MERGE_TARGET_CONTACT = 'SET_MERGE_TARGET_CONTACT';
const SET_CONNECT_INVITE = 'SET_CONNECT_INVITE';
const SET_CURRENT_CONTACT = 'SET_CURRENT_CONTACT';
const SET_NGOS_FOR_PARTERSHIP = 'SET_NGOS_FOR_PARTERSHIP';
const SET_CASE_PROFILE_DIALOG_OPEN_STATE = 'SET_CASE_PROFILE_DIALOG_OPEN_STATE';
const SET_DONATION_PROFILE_DIALOG_OPEN_STATE = 'SET_DONATION_PROFILE_DIALOG_OPEN_STATE';
const RESET_STATE = 'RESET_STATE';

export const ContactActionKeys = {
	fetchMemberProfiles: 'fetchMemberProfiles',
	fetchVolunteerProfiles: 'fetchVolunteerProfiles',
	fetchParticipantProfiles: 'fetchParticipantProfiles',
	fetchJobParticipantProfiles: 'fetchJobParticipantProfiles',
	fetchAllContacts: 'fetchAllContacts',
	fetchApplicationProfiles: 'fetchApplicationProfiles',
	fetchMergeContacts: 'fetchMergeContacts',
	fetchPartners: 'fetchPartners',
	fetchAllPartners: 'fetchAllPartners',
	fetchOwnerCentersForProfile: 'fetchOwnerCentersForProfile',
	fetchAvailableUsersForProfile: 'fetchAvailableUsersForProfile',
	searchContacts: 'searchContacts',
	fetchContactPaymentStatuses: 'fetchContactPaymentStatuses',
	fetchCaseNotes: 'fetchCaseNotes',
	loadContact: 'loadContact',
	loadContacts: 'loadContacts',
	unsetContact: 'unsetContact',
	setSelectedContacts: 'setSelectedContacts',
	clearSelectedContacts: 'clearSelectedContacts',
	loadContactProfile: 'loadContactProfile',
	updateContactProfile: 'updateContactProfile',
	setCurrentContactProfile: 'setCurrentContactProfile',
	setCurrentMembershipApplication: 'setCurrentMembershipApplication',
	unsetCurrentMembershipApplication: 'unsetCurrentMembershipApplication',
	setDraftContactProfileStatus: 'setDraftContactProfileStatus',
	unsetDraftContactProfileStatus: 'unsetDraftContactProfileStatus',
	setDraftContactProfilePaymentStatus: 'setDraftContactProfilePaymentStatus',
	addPendingDraftContactProfilePaymentStatus:
		'addPendingDraftContactProfilePaymentStatus',
	popPendingDraftContactProfilePaymentStatus:
		'popPendingDraftContactProfilePaymentStatus',
	unsetDraftContactProfilePaymentStatus:
		'unsetDraftContactProfilePaymentStatus',
	loadFamilyRelations: 'loadFamilyRelations',
	loadFamilyRelationsByContact: 'loadFamilyRelationsByContact',
	createFamilyRelation: 'createFamilyRelation',
	updateFamilyRelation: 'updateFamilyRelation',
	deleteFamilyRelation: 'deleteFamilyRelation',
	loadCenter: 'loadCenter',
	setCurrentCenter: 'setCurrentCenter',
	setEditing: 'setEditing',
	setContactEditing: 'setContactEditing',
	setContactProfileEditing: 'setContactProfileEditing',
	setNewContactProfileEditing: 'setNewContactProfileEditing',
	setContactRemarksEditing: 'setContactRemarksEditing',
	setFamilyContactEditing: 'setFamilyContactEditing',
	setFamilyContactsEditing: 'setFamilyContactsEditing',
	setMembershipRenewing: 'setMembershipRenewing',
	setFamilyMembersEditing: 'setFamilyMembersEditing',
	setNewFamilyMemberEditing: 'setNewFamilyMemberEditing',
	unsetEditing: 'unsetEditing',
	loadProfileTypes: 'loadProfileTypes',
	loadProfileTypesByContactType: 'loadProfileTypesByContactType',
	setCurrentContactType: 'setCurrentContactType',
	unsetCurrentContactType: 'unsetCurrentContactType',
	setCurrentProfileType: 'setCurrentProfileType',
	unsetCurrentProfileType: 'unsetCurrentProfileType',
	createContactProfile: 'createContactProfile',
	createContactProfilesForFamilyPlan: 'createContactProfilesForFamilyPlan',
	loadFamilyMembers: 'loadFamilyMembers',
	loadAllFamilyProfilesAllMembers: 'loadAllFamilyProfilesAllMembers',
	lookForDuplicateContacts: 'lookForDuplicateContacts',
	unsetDuplicateContacts: 'unsetDuplicateContacts',
	lookForDuplicateFamilyContacts: 'lookForDuplicateFamilyContacts',
	unsetDuplicateFamilyContacts: 'unsetDuplicateFamilyContacts',
	initDraftContact: 'initDraftContact',
	setDraftContact: 'setDraftContact',
	unsetDraftContact: 'unsetDraftContact',
	setDraftFamilyMember: 'setDraftFamilyMember',
	unsetDraftFamilyMember: 'unsetDraftFamilyMember',
	unsetDraftFamilyMembers: 'unsetDraftFamilyMembers',
	setDraftFamilyContact: 'setDraftFamilyContact',
	setDraftFamilyContactProfile: 'setDraftFamilyContactProfile',
	unsetDraftFamilyContact: 'unsetDraftFamilyContact',
	unsetDraftFamilyContacts: 'unsetDraftFamilyContacts',
	setApplicationsForContactsByContact: 'setApplicationsForContactsByContact',
	setApplicationsForContactsByProfile: 'setApplicationsForContactsByProfile',
	clearApplicationsForContact: 'clearApplicationsForContact',
	saveContactRemarksAndInternalFlag: 'saveContactRemarksAndInternalFlag',
	saveContact: 'saveContact',
	setSearchMergeContactBy: 'setSearchMergeContactBy',
	setSearchMergeContactInput: 'setSearchMergeContactInput',
	setMergeTargetContact: 'setMergeTargetContact',
	createConnectInvite: 'createConnectInvite',
	disconnectAppAccount: 'disconnectAppAccount',
	setCurrentContact: 'setCurrentContact',
	unsetCurrentContact: 'unsetCurrentContact',
	fetchNgosForPartership: 'fetchNgosForPartership',
	fetchContactByContactQrCodeId: 'fetchContactByContactQrCodeId',
	fetchContactsByAppUserId: 'fetchContactsByAppUserId',
	openCaseProfileDialog: 'openCaseProfileDialog',
	closeCaseProfileDialog: 'closeCaseProfileDialog',
	openDonationProfileDialog: 'openDonationProfileDialog',
	closeDonationProfileDialog: 'closeDonationProfileDialog',
	resetState: 'resetState',
};

export const ContactGetterKeys = {
	loading: 'loading',
	membersTableData: 'membersTableData',
	volunteersTableData: 'volunteersTableData',
	participantsTableData: 'participantsTableData',
	jobParticipantsTableData: 'jobParticipantsTableData',
	allContactsTableData: 'allContactsTableData',
	applicationsTableData: 'applicationsTableData',
	mergeContactsTableData: 'mergeContactsTableData',
	partnerTableData: 'partnerTableData',
	allPartners: 'allPartners',
	allPartnersUnitMap: 'allPartnersUnitMap',
	contact: 'contact',
	contacts: 'contacts',
	selectedContacts: 'selectedContacts',
	contactPaymentStatuses: 'contactPaymentStatuses',
	currentContactProfile: 'currentContactProfile',
	currentMembershipApplication: 'currentMembershipApplication',
	draftContactProfileStatus: 'draftContactProfileStatus',
	draftContactProfilePaymentStatus: 'draftContactProfilePaymentStatus',
	profileCenters: 'profileCenters',
	profileUsers: 'profileUsers',
	anythingEditing: 'anythingEditing',
	contactEditing: 'contactEditing',
	contactProfileEditing: 'contactProfileEditing',
	newContactProfileEditing: 'newContactProfileEditing',
	contactRemarksEditing: 'contactRemarksEditing',
	familyContactsEditing: 'familyContactsEditing',
	familyContactEditing: 'familyContactEditing',
	membershipRenewing: 'membershipRenewing',
	familyMembersEditing: 'familyMembersEditing',
	newFamilyMemberEditing: 'newFamilyMemberEditing',
	profileTypes: 'profileTypes',
	getProfileTypesByContactType: 'getProfileTypesByContactType',
	contactProfiles: 'contactProfiles',
	caseNotes: 'caseNotes',
	contactProfilesGroupedByContactType: 'contactProfilesGroupedByContactType',
	getContactProfileById: 'getContactProfileById',
	currentContactType: 'currentContactType',
	currentProfileType: 'currentProfileType',
	mainFamilyMember: 'mainFamilyMember',
	getFamilyRelationsByContact: 'getFamilyRelationsByContact',
	familyMembers: 'familyMembers',
	allFamilyProfilesAllMembers: 'allFamilyProfilesAllMembers',
	currentCenter: 'currentCenter',
	duplicateContactCandidates: 'duplicateContactCandidates',
	getDuplicateFamilyContactCandidates: 'getDuplicateFamilyContactCandidates',
	draftContact: 'draftContact',
	draftFamilyMembers: 'draftFamilyMembers',
	draftFamilyContactsWithRelations: 'draftFamilyContactsWithRelations',
	getDraftFamilyMemberByKey: 'getDraftFamilyMemberByKey',
	familyRelations: 'familyRelations',
	applicationsForContacts: 'applicationsForContacts',
	searchMergeContactBy: 'searchMergeContactBy',
	searchMergeContactInput: 'searchMergeContactInput',
	mergeTargetContact: 'mergeTargetContact',
	contactSearchResult: 'contactSearchResult',
	connectInvite: 'connectInvite',
	currentContact: 'currentContact',
	ngosForPartership: 'ngosForPartership',
	caseProfileDialogOpen: 'caseProfileDialogOpen',
	donationProfileDialogOpen: 'donationProfileDialogOpen',
};

const initialState: ContactState = {
	loading: 0,
	contact: null,
	contacts: [],
	selectedContacts: [],
	mergeTargetContact: null,
	searchMergeContactBy: SearchMergeContactBy.name,
	searchMergeContactInput: null,
	currentContactProfile: null,
	currentMembershipApplication: null,
	draftContact: null,
	draftContactProfileStatus: null,
	draftContactProfilePaymentStatus: null,
	caseNotes: [],
	profileCenters: null,
	profileUsers: null,
	pendingDraftContactProfilePaymentStatus: [],
	draftFamilyContactsWithRelations: [],
	draftFamilyMembers: {},
	editingItem: null,
	familyRelations: [],
	familyRelationsByContact: {},
	currentCenter: null,
	profileTypes: [],
	currentContactType: null,
	currentProfileType: null,
	familyMemberProfiles: [],
	allFamilyProfilesAllMembers: [],
	duplicateContactChecking: {
		contacts: [],
		criteria: {},
	},
	duplicateFamilyContactCheckings: [],
	contactPaymentStatuses: [],
	applicationsForContacts: [],
	membersTableData: { items: [], total: 0 },
	volunteersTableData: { items: [], total: 0 },
	participantsTableData: { items: [], total: 0 },
	jobParticipantsTableData: { items: [], total: 0 },
	allContactsTableData: { items: [], total: 0 },
	applicationsTableData: { items: [], total: 0 },
	mergeContactsTableData: { items: [], total: 0 },
	partnerTableData: { items: [], total: 0 },
	ngosForPartership: { items: [], total: 0 },
	allPartners: [],
	allPartnersUnitMap: {},
	contactSearchResult: [],
	currentContact: undefined,
	connectInvite: undefined,
	caseProfileDialogOpen: false,
	donationProfileDialogOpen: false,
};

const store: Module<ContactState, RootState> = {
	namespaced: true,

	state: cloneDeep(initialState),

	mutations: {
		[SET_MEMBERS_PAGE_DATA](state, { result, total }) {
			state.membersTableData = {
				items: result,
				total: total,
			};
		},

		[SET_VOLUNTEERS_PAGE_DATA](state, { result, total }) {
			state.volunteersTableData = {
				items: result,
				total: total,
			};
		},

		[SET_PARTICIPANTS_PAGE_DATA](state, { result, total }) {
			state.participantsTableData = {
				items: result,
				total: total,
			};
		},

		[SET_JOB_PARTICIPANTS_PAGE_DATA](state, { result, total }) {
			state.jobParticipantsTableData = {
				items: result,
				total: total,
			};
		},

		[SET_ALL_CONTACTS_PAGE_DATA](state, { result, total }) {
			state.allContactsTableData = {
				items: result,
				total: total,
			};
		},

		[SET_MERGE_CONTACTS_PAGE_DATA](state, { result, total }) {
			state.mergeContactsTableData = {
				items: result,
				total: total,
			};
		},

		[SET_CONTACT_SEARCH_RESULT](state, contacts: Contact[]) {
			state.contactSearchResult = contacts;
		},

		[SET_APPLICATIONS_PAGE_DATA](state, { result, total }) {
			state.applicationsTableData = {
				items: result,
				total: total,
			};
		},

		[SET_PARTNER_TABLE_PAGE_DATA](state, { result, total }) {
			state.partnerTableData = {
				items: result,
				total: total,
			};
		},

		[SET_ALL_PARTNERS](state, data) {
			state.allPartners = data;
		},

		[SET_ALL_PARTNERS_UNIT_MAP](state, data) {
			state.allPartnersUnitMap = data;
		},

		[SET_NGOS_FOR_PARTERSHIP](state, { result, total }) {
			state.ngosForPartership = {
				items: result,
				total: total,
			};
		},

		[SET_CONTACT_PAYMENT_STATUSES](state, statuses) {
			state.contactPaymentStatuses = statuses;
		},

		[SET_CONTACT_CASE_NOTES](state, caseNotes) {
			state.caseNotes = caseNotes;
		},

		[SET_CONTACT](state, contact) {
			state.contact = contact;
		},

		[SET_CONTACTS](state, contacts) {
			state.contacts = contacts;
		},

		[SET_SELECTED_CONTACTS](state, selectedContacts) {
			state.selectedContacts = selectedContacts;
		},

		[SET_CURRENT_CONTACT_PROFILE](state, profile) {
			state.currentContactProfile = profile;
		},

		[SET_CURRENT_MEMBERSHIP_APPLICATION](state, application) {
			state.currentMembershipApplication = application;
		},

		[SET_DRAFT_CONTACT_PROFILE_STATUS](state, draftStatus) {
			state.draftContactProfileStatus = draftStatus;
		},

		[SET_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS](state, draftStatus) {
			state.draftContactProfilePaymentStatus = draftStatus;
		},

		[SET_PROFILE_CENTERS](state, profileCenters) {
			state.profileCenters = profileCenters;
		},

		[SET_PROFILE_USERS](state, profileUsers) {
			state.profileUsers = profileUsers;
		},

		[ADD_PENDING_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS](state, paymentStatus) {
			state.pendingDraftContactProfilePaymentStatus = [
				...state.pendingDraftContactProfilePaymentStatus,
				paymentStatus,
			];
		},

		[POP_PENDING_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS](state) {
			state.pendingDraftContactProfilePaymentStatus = state.pendingDraftContactProfilePaymentStatus.filter(
				(_, i) => i != 0,
			);
		},

		[SET_EDITING](state, item: ContactEditableItem | null) {
			state.editingItem = item;
		},

		[SET_FAMILY_RELATIONS](state, relations: FamilyRelation[]) {
			state.familyRelations = relations;
		},

		[SET_FAMILY_RELATIONS_BY_CONTACT](
			state,
			{
				contactId,
				relations,
			}: { contactId: number; relations: FamilyRelation[] },
		) {
			Vue.set(state.familyRelationsByContact, contactId, relations);
		},

		[SET_CURRENT_CENTER](state, center: Center) {
			state.currentCenter = center;
		},

		[SET_PROFILE_TYPES](state, profileTypes: ProfileType[]) {
			state.profileTypes = profileTypes;
		},

		[SET_PROFILE_TYPES_BY_CONTACT_TYPE](
			state,
			{
				profileTypes: newProfileTypes,
				contactType,
			}: { profileTypes: ProfileType[]; contactType: ContactTypeCode },
		) {
			const oldProfileTypesOfOtherContactTypes = state.profileTypes.filter(
				profileType => profileType.contactType !== contactType,
			);
			state.profileTypes = [
				...oldProfileTypesOfOtherContactTypes,
				...newProfileTypes,
			];
		},

		[SET_CURRENT_CONTACT_TYPE](state, contactType) {
			state.currentContactType = contactType;
		},

		[SET_CURRENT_PROFILE_TYPE](state, profileType) {
			state.currentProfileType = profileType;
		},

		[SET_FAMILY_MEMBER_PROFILES](state, profiles: ContactProfile[]) {
			state.familyMemberProfiles = profiles;
		},
		[SET_ALL_FAMILY_PROFILES_ALL_MEMBER_PROFILES](
			state,
			profiles: ContactProfile[],
		) {
			state.allFamilyProfilesAllMembers = profiles;
		},

		[SET_DUPLICATE_CONTACT_CHECKING_CONTACTS](state, contacts) {
			state.duplicateContactChecking.contacts = contacts;
		},

		[SET_DUPLICATE_CONTACT_CHECKING_CRITERIA](state, criteria) {
			state.duplicateContactChecking.criteria = criteria;
		},

		[SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CONTACTS](
			state,
			{ index, contacts },
		) {
			if (!state.duplicateFamilyContactCheckings[index]) {
				Vue.set(state.duplicateFamilyContactCheckings, index, {
					contacts: contacts,
					criteria: {},
				});
			} else {
				Vue.set(
					state.duplicateFamilyContactCheckings[index],
					'contacts',
					contacts,
				);
			}
		},

		[SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CRITERIA](
			state,
			{ index, criteria },
		) {
			if (state.duplicateFamilyContactCheckings[index]) {
				Vue.set(
					state.duplicateFamilyContactCheckings[index],
					'criteria',
					criteria,
				);
			} else {
				Vue.set(state.duplicateFamilyContactCheckings, index, {
					contacts: [],
					criteria: criteria,
				});
			}
		},

		[UNSET_DUPLICATE_FAMILY_CONTACT_CHECKING](state, index) {
			Vue.delete(state.duplicateFamilyContactCheckings, index);
		},

		[SET_DRAFT_CONTACT](state, contact: ContactDto | null) {
			state.draftContact = contact;
		},

		[SET_DRAFT_FAMILY_MEMBER_BY_KEY](
			state,
			{ key, profile }: { key: number; profile: ContactProfileDto },
		) {
			Vue.set(state.draftFamilyMembers, key, profile);
		},

		[UNSET_DRAFT_FAMILY_MEMBER_BY_KEY](state, key) {
			Vue.delete(state.draftFamilyMembers, key);
		},

		[UNSET_DRAFT_FAMILY_MEMBERS](state) {
			state.draftFamilyMembers = {};
		},

		[SET_DRAFT_FAMILY_CONTACT_BY_INDEX](
			state,
			{
				index,
				contact,
				relation,
			}: { index: number; contact?: ContactDto; relation?: RelationCode },
		) {
			if (contact)
				Vue.set(state.draftFamilyContactsWithRelations[index], 'contact', {
					...contact,
					// keep contact profiles
					contactProfiles:
						state.draftFamilyContactsWithRelations[index].contact
							.contactProfiles,
				});
			if (relation)
				Vue.set(
					state.draftFamilyContactsWithRelations[index],
					'relation',
					relation,
				);
		},

		[SET_DRAFT_FAMILY_CONTACT_PROFILE_BY_INDEX](
			state,
			{ index, profile }: { index: number; profile: ContactProfileDto },
		) {
			if (!state.draftFamilyContactsWithRelations[index]) {
				state.draftFamilyContactsWithRelations[index] = {
					contact: { contactProfiles: [] },
				};
			}

			Vue.set(
				state.draftFamilyContactsWithRelations[index].contact,
				'contactProfiles',
				[profile],
			);
		},

		[ADD_DRAFT_FAMILY_CONTACT](
			state,
			{ contact, relation }: { contact?: ContactDto; relation?: RelationCode },
		) {
			state.draftFamilyContactsWithRelations.push({
				contact: contact || { contactProfiles: [] },
				relation: relation,
			});
		},

		[UNSET_DRAFT_FAMILY_CONTACT_BY_INDEX](state, index: number) {
			Vue.delete(state.draftFamilyContactsWithRelations, index);
		},

		[UNSET_DRAFT_FAMILY_CONTACTS](state) {
			state.draftFamilyContactsWithRelations = [];
		},

		[SET_APPS_FOR_CONTACTS](state, contactIds) {
			state.applicationsForContacts = contactIds;
		},

		[SHOW_LOADING](state) {
			state.loading += 1;
		},

		[HIDE_LOADING](state) {
			state.loading -= 1;
		},

		[SET_SEARCH_MERGE_CONTACT_BY](state, input) {
			state.searchMergeContactBy = input;
		},

		[SET_SEARCH_MERGE_CONTACT_INPUT](state, input) {
			state.searchMergeContactInput = input;
		},

		[SET_MERGE_TARGET_CONTACT](state, contact) {
			state.mergeTargetContact = contact;
		},

		[SET_CONNECT_INVITE](state, invite) {
			state.connectInvite = invite;
		},

		[SET_CURRENT_CONTACT](state, contact) {
			state.currentContact = contact;
		},

		[SET_CASE_PROFILE_DIALOG_OPEN_STATE](state, isOpen) {
			state.caseProfileDialogOpen = isOpen;
		},

		[SET_DONATION_PROFILE_DIALOG_OPEN_STATE](state, isOpen) {
			state.donationProfileDialogOpen = isOpen;
		},

		[RESET_STATE](state) {
			Object.assign(state, initialState);
		},
	},

	actions: {
		async [ContactActionKeys.fetchMemberProfiles](
			{ commit },
			options: TableItemsOptions,
		) {
			try {
				commit(SHOW_LOADING);
				const { result, total } = await api.fetchMemberItems(options);
				commit(SET_MEMBERS_PAGE_DATA, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchVolunteerProfiles](
			{ commit },
			options: TableItemsOptions,
		) {
			try {
				commit(SHOW_LOADING);
				const { result, total } = await api.fetchVolunteerItems(options);
				commit(SET_VOLUNTEERS_PAGE_DATA, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchParticipantProfiles](
			{ commit },
			options: TableItemsOptions,
		) {
			try {
				commit(SHOW_LOADING);
				const { result, total } = await api.fetchParticipantItems(options);
				commit(SET_PARTICIPANTS_PAGE_DATA, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchJobParticipantProfiles](
			{ commit },
			options: TableItemsOptions,
		) {
			try {
				commit(SHOW_LOADING);
				const { result, total } = await api.fetchJobParticipantItems(options);
				commit(SET_JOB_PARTICIPANTS_PAGE_DATA, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchAllContacts](
			{ commit },
			{ options }: { options: TableItemsOptions },
		) {
			try {
				commit(SHOW_LOADING);
				const { result, total } = await api.fetchAllContactsItems(options);
				commit(SET_ALL_CONTACTS_PAGE_DATA, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchApplicationProfiles](
			{ commit },
			options: TableItemsOptions,
		) {
			try {
				commit(SHOW_LOADING);
				const { result, total } = await api.fetchApplicationItems(options);
				commit(SET_APPLICATIONS_PAGE_DATA, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchMergeContacts](
			{ commit, state },
			{
				targetContactId,
				field,
				search,
			}: {
				targetContactId: number;
				field: string;
				search: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const result = await api.fetchAllDuplicateContacts(targetContactId, {
					field,
					search,
				});
				//Contact with same app_user_id should be selected by default
				commit(
					SET_SELECTED_CONTACTS,
					result.filter(contact => {
						return (
							state.mergeTargetContact?.appUserId &&
							contact.appUserId === state.mergeTargetContact?.appUserId
						);
					}),
				);
				const total = result.length;
				commit(SET_MERGE_CONTACTS_PAGE_DATA, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchPartners](
			{ commit },
			{ options }: { options: TableItemsOptions },
		) {
			try {
				commit(SHOW_LOADING);
				const { result, total } = await api.contact.fetchPartnersItems(options);
				commit(SET_PARTNER_TABLE_PAGE_DATA, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchAllPartners](
			{ commit },
			{ withDeleted }: { withDeleted?: boolean },
		) {
			const partners = await api.contact.fetchPartners(withDeleted);
			const allPartnersUnitMap: AllPartnersUnitMap = {};
			for (const partner of partners) {
				const ngoId = partner.partnerNgoId;
				const centers = partner.centers ?? [];
				if (ngoId && !partner.isExternal) {
					allPartnersUnitMap[ngoId] = centers;
				}
			}
			commit(SET_ALL_PARTNERS, partners);
			commit(SET_ALL_PARTNERS_UNIT_MAP, allPartnersUnitMap);
		},

		async [ContactActionKeys.fetchOwnerCentersForProfile](
			{ commit },
			{ profileId }: { profileId: number },
		) {
			commit(
				SET_PROFILE_CENTERS,
				await api.contact.fetchOwnerCentersForProfile(profileId),
			);
		},

		async [ContactActionKeys.fetchAvailableUsersForProfile](
			{ commit },
			{ profileId }: { profileId: number },
		) {
			commit(
				SET_PROFILE_USERS,
				await api.contact.fetchAvailableUsersForProfile(profileId),
			);
		},

		async [ContactActionKeys.fetchNgosForPartership](
			{ commit },
			{ options }: { options: TableItemsOptions },
		) {
			try {
				commit(SHOW_LOADING);
				const { result, total } = await api.contact.fetchNgoForPartnershipItems(
					options,
				);
				commit(SET_NGOS_FOR_PARTERSHIP, { result, total });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.searchContacts](
			{ commit },
			{ conditions }: { conditions: ContactSearchCondition[] },
		) {
			try {
				commit(SHOW_LOADING);
				// clear first
				commit(SET_CONTACT_SEARCH_RESULT, []);

				const contacts = await api.searchContacts(conditions);
				commit(SET_CONTACT_SEARCH_RESULT, contacts);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchContactPaymentStatuses]({ state, commit }) {
			if (state.contactPaymentStatuses.length) return;
			try {
				commit(SHOW_LOADING);
				commit(
					SET_CONTACT_PAYMENT_STATUSES,
					await api.fetchContactPaymentStatuses(),
				);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.fetchCaseNotes](
			{ commit },
			{ profileId }: { profileId: number },
		) {
			commit(SET_CONTACT_CASE_NOTES, []);
			commit(
				SET_CONTACT_CASE_NOTES,
				await api.contact.fetchContactProfileCaseNotes(profileId),
			);
		},

		async [ContactActionKeys.loadContact]({ commit }, { id }) {
			commit(SET_CONTACT, null); // clear old contact first
			const contact = await api.fetchContact(id);
			commit(SET_CONTACT, contact);
		},
		[ContactActionKeys.unsetContact]({ commit }) {
			commit(SET_CONTACT, null);
		},

		async [ContactActionKeys.loadContacts]({ commit }) {
			const contacts = await api.fetchContacts();
			commit(SET_CONTACTS, contacts);
		},

		async [ContactActionKeys.fetchContactsByAppUserId](
			{ commit },
			appUserId: string,
		) {
			const criteria = {
				appUserIds: [appUserId],
			};
			const contacts = await api.fetchContacts(criteria);
			if (contacts.length > 0) {
				commit(SET_CURRENT_CONTACT, contacts[0]);
				return contacts[0];
			}
			return null;
		},

		async [ContactActionKeys.fetchContactByContactQrCodeId]({ commit }, id) {
			const contact = (await contactApi.getQrCode(id))?.contact;
			commit(SET_CURRENT_CONTACT, contact);
			return contact;
		},

		[ContactActionKeys.unsetContact]({ commit }) {
			commit(SET_CONTACT, null);
		},

		[ContactActionKeys.setSelectedContacts](
			{ commit },
			{ selectedContacts }: { selectedContacts: Contact[] },
		) {
			commit(SET_SELECTED_CONTACTS, selectedContacts);
		},

		[ContactActionKeys.clearSelectedContacts]({ commit }) {
			commit(SET_SELECTED_CONTACTS, []);
		},

		async [ContactActionKeys.loadContactProfile](
			{ commit },
			{
				contactProfileId,
				withDeleted,
			}: {
				contactProfileId: number;
				withDeleted?: boolean;
			},
		) {
			commit(SET_CURRENT_CONTACT_PROFILE, null); // clear old one first
			const profile = await api.fetchContactProfile(
				contactProfileId,
				withDeleted,
			);
			commit(SET_CURRENT_CONTACT_PROFILE, profile);
		},
		async [ContactActionKeys.updateContactProfile](
			{ commit },
			{ contactProfile },
		) {
			const profile = await api.updateContactProfile(contactProfile);
			commit(SET_CURRENT_CONTACT_PROFILE, profile);
		},
		[ContactActionKeys.setCurrentContactProfile](
			{ commit },
			{ contactProfile },
		) {
			commit(SET_CURRENT_CONTACT_PROFILE, contactProfile);
		},
		[ContactActionKeys.setCurrentMembershipApplication](
			{ commit },
			{ application },
		) {
			commit(SET_CURRENT_MEMBERSHIP_APPLICATION, application);
		},
		[ContactActionKeys.unsetCurrentMembershipApplication]({ commit }) {
			commit(SET_CURRENT_MEMBERSHIP_APPLICATION, null);
		},

		[ContactActionKeys.setDraftContactProfileStatus]({ commit }, { status }) {
			commit(SET_DRAFT_CONTACT_PROFILE_STATUS, status);
		},
		[ContactActionKeys.unsetDraftContactProfileStatus]({ commit }) {
			commit(SET_DRAFT_CONTACT_PROFILE_STATUS, null);
		},
		[ContactActionKeys.setDraftContactProfilePaymentStatus](
			{ commit },
			{ status },
		) {
			if (!['paid', 'waived', 'free'].includes(status)) {
				throw new Error('not implemented');
			}

			commit(SET_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS, status);
		},
		[ContactActionKeys.addPendingDraftContactProfilePaymentStatus](
			{ commit },
			paymentStatus: { status: string; currentProfile: ContactProfile },
		) {
			if (!['paid', 'waived', 'free'].includes(paymentStatus.status)) {
				throw new Error('not implemented');
			}

			commit(ADD_PENDING_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS, paymentStatus);
		},
		[ContactActionKeys.popPendingDraftContactProfilePaymentStatus]({
			state,
			commit,
			getters,
			dispatch,
		}) {
			if (state.pendingDraftContactProfilePaymentStatus.length > 0) {
				const {
					status,
					currentProfile,
				} = state.pendingDraftContactProfilePaymentStatus[0];
				dispatch(ContactActionKeys.setDraftContactProfilePaymentStatus, {
					status,
				});
				dispatch(ContactActionKeys.setCurrentContactProfile, {
					contactProfile: currentProfile,
				});
				commit(POP_PENDING_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS);
			} else {
				if (getters.contact) {
					//in case of edit, reload contact
					dispatch(ContactActionKeys.loadContact, { id: getters.contact.id });
				}
				dispatch(ContactActionKeys.unsetDraftContactProfilePaymentStatus);
				dispatch(ContactActionKeys.unsetCurrentProfileType);
			}
		},
		[ContactActionKeys.unsetDraftContactProfilePaymentStatus]({ commit }) {
			commit(SET_DRAFT_CONTACT_PROFILE_PAYMENT_STATUS, null);
		},
		async [ContactActionKeys.loadFamilyRelations]({ getters, commit }) {
			try {
				commit(SHOW_LOADING);
				const contactId = getters.contact?.id;
				if (!contactId) {
					throw new Error('No valid contact Id');
				}
				const relations = await api.fetchFamilyRelationsByContact(contactId);
				commit(SET_FAMILY_RELATIONS, relations);
			} finally {
				commit(HIDE_LOADING);
			}
		},
		async [ContactActionKeys.loadFamilyRelationsByContact](
			{ commit },
			{ contactId },
		) {
			if (!contactId) {
				throw new Error('No valid contact Id');
			}
			const relations = await api.fetchFamilyRelationsByContact(contactId);
			commit(SET_FAMILY_RELATIONS_BY_CONTACT, { contactId, relations });

			// load main applicant
			const contact = await api.fetchContact(contactId);
			commit(SET_CONTACTS, [contact]);
		},
		async [ContactActionKeys.createFamilyRelation](
			{ dispatch },
			{ contactId, relation },
		) {
			await api.createFamilyRelation(contactId, relation);
			dispatch('loadFamilyRelations');
		},
		async [ContactActionKeys.updateFamilyRelation](
			{ dispatch },
			{ relation }: { relation: FamilyRelation },
		) {
			await api.updateFamilyRelation(relation.id, relation);
			dispatch('loadFamilyRelations');
		},
		async [ContactActionKeys.deleteFamilyRelation](
			{ dispatch },
			{ relationId },
		) {
			await api.deleteFamilyRelation(relationId);
			dispatch('loadFamilyRelations');
		},

		async [ContactActionKeys.loadCenter]({ commit }, { centerId }) {
			const center = await api.fetchCenter(centerId);
			commit(SET_CURRENT_CENTER, center);
		},

		[ContactActionKeys.setCurrentCenter]({ commit }, { center }) {
			commit(SET_CURRENT_CENTER, center);
		},

		[ContactActionKeys.setEditing](
			{ getters, commit },
			{ item }: { item: ContactEditableItem },
		) {
			// validate
			if (getters.anythingEditing) {
				throw new Error(`Cannot edit multiple items at the same time`); // message for internal use, should not happen
			}
			commit(SET_EDITING, item);
		},

		[ContactActionKeys.setContactEditing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.contact });
		},

		[ContactActionKeys.setContactProfileEditing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.contactProfile });
		},

		[ContactActionKeys.setNewContactProfileEditing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.newContactProfile });
		},

		[ContactActionKeys.setContactRemarksEditing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.contactRemarks });
		},

		[ContactActionKeys.setFamilyContactEditing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.familyContact });
		},

		[ContactActionKeys.setFamilyContactsEditing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.familyContacts });
		},

		[ContactActionKeys.setMembershipRenewing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.membershipRenew });
		},

		[ContactActionKeys.setFamilyMembersEditing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.familyMembers });
		},

		[ContactActionKeys.setNewFamilyMemberEditing]({ dispatch }) {
			dispatch('setEditing', { item: ContactEditableItem.newFamilyMember });
		},

		[ContactActionKeys.unsetEditing]({ commit }) {
			commit(SET_EDITING, null);
		},

		async [ContactActionKeys.loadProfileTypes]({ commit }) {
			const profileTypes = await api.fetchProfileTypes();
			commit(SET_PROFILE_TYPES, profileTypes);
		},

		async [ContactActionKeys.loadProfileTypesByContactType](
			{ commit, getters },
			{ contactType }: { contactType: ContactTypeCode },
		) {
			if (getters.getProfileTypesByContactType(contactType).length) {
				// skip if already loaded
				return;
			}
			const profileTypes = await api.fetchProfileTypes(contactType);
			commit(SET_PROFILE_TYPES_BY_CONTACT_TYPE, { contactType, profileTypes });
		},

		[ContactActionKeys.setCurrentContactType](
			{ commit },
			{ contactType }: { contactType: ContactTypeCode },
		) {
			commit(SET_CURRENT_CONTACT_TYPE, contactType);
		},

		[ContactActionKeys.unsetCurrentContactType]({ commit }) {
			commit(SET_CURRENT_CONTACT_TYPE, null);
		},

		[ContactActionKeys.setCurrentProfileType](
			{ commit },
			{ profileType }: { profileType: ProfileType },
		) {
			commit(SET_CURRENT_PROFILE_TYPE, profileType);
		},

		[ContactActionKeys.unsetCurrentProfileType]({ commit }) {
			commit(SET_CURRENT_PROFILE_TYPE, null);
		},

		async [ContactActionKeys.createContactProfile](
			{ getters, dispatch },
			{
				contactProfile,
				payNext,
				batch,
				batchLast,
			}: {
				contactProfile: ContactProfileDto;
				payNext?: boolean;
				batch?: boolean;
				batchLast?: boolean;
			},
		) {
			if (!contactProfile) throw new Error('Profile must not be empty');
			try {
				const newProfile = await api.createContactProfile(contactProfile);

				if (newProfile.id) {
					if (payNext) {
						dispatch(
							ContactActionKeys.addPendingDraftContactProfilePaymentStatus,
							{
								status: 'paid',
								currentProfile: newProfile,
							},
						);
					}
				}
				if (!batch || batchLast) {
					dispatch(
						ContactActionKeys.popPendingDraftContactProfilePaymentStatus,
					);
					//ContactActionKeys.loadContact is not called until payment finished, so unset it here first
					dispatch(ContactActionKeys.unsetEditing);
				}
			} catch (e) {
				//in case of errors, refresh the page to load latest added profiles
				if (getters.contact) {
					dispatch(ContactActionKeys.loadContact, { id: getters.contact.id });
				}
				throw e;
			}
		},

		async [ContactActionKeys.createContactProfilesForFamilyPlan](
			{ getters, dispatch },
			{
				contactProfiles,
				payNext,
				batch,
				batchLast,
			}: {
				contactProfiles: ContactProfileDto[];
				payNext?: boolean;
				batch?: boolean;
				batchLast?: boolean;
			},
		) {
			if (!contactProfiles || !contactProfiles.length)
				throw new Error('Profile must not be empty');
			try {
				const newProfiles = await api.createContactProfilesForFamilyPlan(
					contactProfiles,
				);

				if (newProfiles.length && newProfiles[0].id) {
					if (payNext) {
						dispatch(
							ContactActionKeys.addPendingDraftContactProfilePaymentStatus,
							{
								status: 'paid',
								currentProfile: newProfiles[0],
							},
						);
					}
				}
				if (!batch || batchLast) {
					dispatch(
						ContactActionKeys.popPendingDraftContactProfilePaymentStatus,
					);
					//ContactActionKeys.loadContact is not called until payment finished, so unset it here first
					dispatch(ContactActionKeys.unsetEditing);
				}
			} catch (e) {
				//in case of errors, refresh the page to load latest added profiles
				if (getters.contact) {
					dispatch(ContactActionKeys.loadContact, { id: getters.contact.id });
				}
				throw e;
			}
		},

		async [ContactActionKeys.loadFamilyMembers](
			{ commit, dispatch },
			{ contactProfile }: { contactProfile: ContactProfile },
		) {
			try {
				commit(SHOW_LOADING);
				// abort if not valid
				if (
					!(
						contactProfile &&
						contactProfile.paymentId &&
						contactProfile.profileType?.category ===
							ProfileTypeCategoryCode.family
					)
				)
					throw new Error('Not a valid family member');

				const profiles: ContactProfile[] = await api.fetchContactProfilesUnderSamePlan(
					contactProfile,
				);
				commit(SET_FAMILY_MEMBER_PROFILES, profiles);

				// skip if empty
				if (!profiles.length) return;

				const mainApplicant = profiles.find(
					profile => profile.familyApplicantType === FamilyApplicantType.main,
				);
				if (!mainApplicant)
					throw new Error('Unexpectedly missing main applicant');
				dispatch('loadFamilyRelationsByContact', {
					contactId: mainApplicant.contactId,
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ContactActionKeys.loadAllFamilyProfilesAllMembers](
			{ commit },
			{ contactProfile }: { contactProfile: ContactProfile },
		) {
			// reset first
			commit(SET_ALL_FAMILY_PROFILES_ALL_MEMBER_PROFILES, []);

			// abort if not valid
			if (
				!(
					contactProfile &&
					contactProfile.profileType?.category ===
						ProfileTypeCategoryCode.family
				)
			)
				throw new Error('Not a valid family member');
			const profiles: ContactProfile[] = await api.fetchContactProfilesUnderSameProfileType(
				contactProfile,
			);

			// skip if empty
			if (!profiles.length) return;

			const relatedProfiles: ContactProfile[] = await api.fetchContactProfilesRelatedToAllContactProfiles(
				profiles
					.map(profile => profile.paymentId)
					.filter(paymentId => !!paymentId) as string[],
			);

			commit(SET_ALL_FAMILY_PROFILES_ALL_MEMBER_PROFILES, relatedProfiles);
		},

		[ContactActionKeys.lookForDuplicateContacts]: debounce(
			async ({ commit, state }, { contact }: { contact: ContactDto }) => {
				const { fullNameChi, firstNameEng, lastNameEng } = contact;
				const criteria = {
					fullNameChi,
					firstNameEng,
					lastNameEng,
				};

				if (isEqual(state.duplicateContactChecking.criteria, criteria)) {
					// skip if criteria is same
					return;
				}
				commit(SET_DUPLICATE_CONTACT_CHECKING_CRITERIA, criteria);
				// unset contacts first, so we don't show wrong data while loading
				commit(SET_DUPLICATE_CONTACT_CHECKING_CONTACTS, []);

				if (
					fullNameChi
						? (firstNameEng && lastNameEng) || !(firstNameEng || lastNameEng)
						: firstNameEng && lastNameEng
				) {
					// criteria is valid
					const contacts = await api.fetchContacts(criteria);
					commit(SET_DUPLICATE_CONTACT_CHECKING_CONTACTS, contacts);
				}
			},
			200,
		),

		[ContactActionKeys.unsetDuplicateContacts]({ commit }) {
			commit(SET_DUPLICATE_CONTACT_CHECKING_CRITERIA, {});
			commit(SET_DUPLICATE_CONTACT_CHECKING_CONTACTS, []);
		},

		[ContactActionKeys.lookForDuplicateFamilyContacts]: debounce(
			async (
				{ commit, state },
				{ index, contact }: { index: number; contact: ContactDto },
			) => {
				const { fullNameChi, firstNameEng, lastNameEng } = contact;
				const criteria = {
					fullNameChi,
					firstNameEng,
					lastNameEng,
				};

				if (isEqual(state.duplicateContactChecking.criteria, criteria)) {
					// skip if criteria is same
					return;
				}
				commit(SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CRITERIA, {
					index,
					criteria,
				});
				// unset contacts first, so we don't show wrong data while loading
				commit(SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CONTACTS, {
					index,
					contacts: [],
				});

				if (
					fullNameChi
						? (firstNameEng && lastNameEng) || !(firstNameEng || lastNameEng)
						: firstNameEng && lastNameEng
				) {
					// criteria is valid
					const contacts = await api.fetchContacts(criteria);
					commit(SET_DUPLICATE_FAMILY_CONTACT_CHECKING_CONTACTS, {
						index,
						contacts,
					});
				}
			},
			200,
		),

		[ContactActionKeys.unsetDuplicateFamilyContacts]({ commit }, { index }) {
			commit(UNSET_DUPLICATE_FAMILY_CONTACT_CHECKING, index);
		},

		[ContactActionKeys.initDraftContact]({ commit, getters }) {
			commit(SET_DRAFT_CONTACT, cloneDeep(getters[ContactGetterKeys.contact]));
		},

		[ContactActionKeys.setDraftContact](
			{ commit },
			{ contact }: { contact: ContactDto },
		) {
			commit(SET_DRAFT_CONTACT, contact);
		},

		[ContactActionKeys.unsetDraftContact]({ commit }) {
			commit(SET_DRAFT_CONTACT, null);
		},

		// Note: for some reason the state `draftFamilyMembers` is an array
		// TODO: maybe revamp this to set Array rather than object, one by one
		[ContactActionKeys.setDraftFamilyMember](
			{ commit, state, getters },
			{ key, profile }: { key?: number; profile: ContactProfileDto },
		) {
			if (
				!key &&
				profile.contactId &&
				state.draftFamilyMembers &&
				Object.keys(state.draftFamilyMembers).length
			) {
				key = Number(
					Object.entries(state.draftFamilyMembers).find(
						// eslint-disable-next-line @typescript-eslint/no-unused-vars
						([_, draftFamilyMember]) =>
							draftFamilyMember.contactId === profile.contactId,
					)?.[0],
				);
			}

			if (key) {
				// prevent overwriting contact & contactId
				const oldProfile: ContactProfileDto = getters.getDraftFamilyMemberByKey(
					key,
				);
				profile.contactId = oldProfile.contactId;
				profile.contact = oldProfile.contact;
			} else {
				/**
				 * Previously time by milliseconds was used; hence
				 * introduced a bug where sometimes when run too fast,
				 * different entry results in same Key, and consider as duplicate
				 */
				key = Number(`${profile.contactId}${new Date().getTime() % 1e4}`);
			}
			commit(SET_DRAFT_FAMILY_MEMBER_BY_KEY, { key, profile });
		},

		[ContactActionKeys.unsetDraftFamilyMember](
			{ commit },
			{ key }: { key: number },
		) {
			commit(UNSET_DRAFT_FAMILY_MEMBER_BY_KEY, key);
		},

		[ContactActionKeys.unsetDraftFamilyMembers]({ commit }) {
			commit(UNSET_DRAFT_FAMILY_MEMBERS);
		},

		[ContactActionKeys.setDraftFamilyContact](
			{ commit },
			{
				index,
				contact,
				relation,
			}: { index?: number; contact?: ContactDto; relation?: RelationCode },
		) {
			if (typeof index === 'number' && index > -1) {
				commit(SET_DRAFT_FAMILY_CONTACT_BY_INDEX, { index, contact, relation });
			} else {
				commit(ADD_DRAFT_FAMILY_CONTACT, { contact, relation });
			}
		},

		[ContactActionKeys.setDraftFamilyContactProfile](
			{ commit },
			{ index, profile }: { index?: number; profile: ContactProfileDto },
		) {
			if (!(typeof index === 'number' && index > -1))
				throw new Error(`Invalid index ${index}`);
			commit(SET_DRAFT_FAMILY_CONTACT_PROFILE_BY_INDEX, { index, profile });
		},

		[ContactActionKeys.unsetDraftFamilyContact](
			{ commit },
			{ index }: { index: number },
		) {
			commit(UNSET_DRAFT_FAMILY_CONTACT_BY_INDEX, index);
		},

		[ContactActionKeys.unsetDraftFamilyContacts]({ commit }) {
			commit(UNSET_DRAFT_FAMILY_CONTACTS);
		},

		async [ContactActionKeys.setApplicationsForContactsByContact](
			{ commit },
			contact: Contact,
		) {
			const setOfContactIds = new Set();
			setOfContactIds.add(contact.id);
			const profiles = await api.fetchContactProfilesByContact(contact.id);
			for (const profile of profiles) {
				if (profile.familyApplicantType === FamilyApplicantType.dependant) {
					const mainApplicantProfile = await api.fetchMainContactProfileByProfile(
						profile,
					);
					setOfContactIds.add(mainApplicantProfile.contactId);
				}
			}
			commit(
				SET_APPS_FOR_CONTACTS,
				Array.from(setOfContactIds).filter(Boolean),
			);
		},

		async [ContactActionKeys.setApplicationsForContactsByProfile](
			{ commit },
			profile: ContactProfile,
		) {
			const setOfContactIds = new Set();
			setOfContactIds.add(profile.contactId);
			if (profile.familyApplicantType === FamilyApplicantType.dependant) {
				const mainApplicantProfile = await api.fetchMainContactProfileByProfile(
					profile,
				);
				setOfContactIds.add(mainApplicantProfile.contactId);
			}
			commit(
				SET_APPS_FOR_CONTACTS,
				Array.from(setOfContactIds).filter(Boolean),
			);
		},

		[ContactActionKeys.clearApplicationsForContact]({ commit }) {
			commit(SET_APPS_FOR_CONTACTS, []);
		},

		async [ContactActionKeys.saveContactRemarksAndInternalFlag](
			{ commit, state },
			{
				remarks,
				internalFlag,
			}: {
				remarks: string;
				internalFlag?: string;
			},
		) {
			const contact = state.contact;
			if (!contact || !contact.id) throw 'no contact to update remarks';

			let draftContactData = cloneDeep(contact.data);
			if (!draftContactData) draftContactData = {};
			draftContactData.remarks = remarks;
			if (internalFlag !== undefined) {
				draftContactData.internalFlag = internalFlag || '';
			}

			const updatedContact = await api.updateContact(contact.id, {
				...contact,
				data: draftContactData,
			});
			commit(SET_CONTACT, updatedContact);
		},

		async [ContactActionKeys.saveContact](
			{ commit, state },
			{ contactDto }: { contactDto?: ContactDto },
		) {
			const contactDtoToBeSaved = contactDto || state.draftContact;
			if (!contactDtoToBeSaved || !state.contact) throw 'no contact for update';
			const updatedContact = await api.updateContact(
				state.contact.id,
				contactDtoToBeSaved,
			);
			commit(SET_CONTACT, updatedContact);
		},

		[ContactActionKeys.setSearchMergeContactBy](
			{ commit },
			{ searchBy }: { searchBy: SearchMergeContactBy },
		) {
			commit(SET_SEARCH_MERGE_CONTACT_BY, searchBy);
		},

		[ContactActionKeys.setSearchMergeContactInput](
			{ commit },
			{ input }: { input: string },
		) {
			commit(SET_SEARCH_MERGE_CONTACT_INPUT, input);
		},

		[ContactActionKeys.setMergeTargetContact](
			{ commit },
			{ contact }: { contact: Contact },
		) {
			commit(SET_SEARCH_MERGE_CONTACT_BY, SearchMergeContactBy.name);
			commit(SET_MERGE_TARGET_CONTACT, contact);
		},

		async [ContactActionKeys.createConnectInvite](
			{ commit },
			{ contactId, email }: { contactId: number; email?: string },
		) {
			const invite = await api.createConnectInvite(contactId, email);
			commit(SET_CONTACT, invite);
		},

		async [ContactActionKeys.disconnectAppAccount](
			{ commit },
			{ contactId }: { contactId: number; email?: string },
		) {
			await api.disconnectAppAccount(contactId);
			commit(SET_CONTACT, null);
		},

		async [ContactActionKeys.setCurrentContact](
			{ commit },
			{ contact }: { contact: Contact },
		) {
			commit(SET_CURRENT_CONTACT, contact);
		},

		async [ContactActionKeys.unsetCurrentContact]({ commit }) {
			commit(SET_CURRENT_CONTACT, undefined);
		},

		[ContactActionKeys.openCaseProfileDialog]({ commit }) {
			commit(SET_CASE_PROFILE_DIALOG_OPEN_STATE, true);
		},

		[ContactActionKeys.closeCaseProfileDialog]({ commit }) {
			commit(SET_CASE_PROFILE_DIALOG_OPEN_STATE, false);
		},

		[ContactActionKeys.openDonationProfileDialog]({ commit }) {
			commit(SET_DONATION_PROFILE_DIALOG_OPEN_STATE, true);
		},

		[ContactActionKeys.closeDonationProfileDialog]({ commit }) {
			commit(SET_DONATION_PROFILE_DIALOG_OPEN_STATE, false);
		},

		async [ContactActionKeys.resetState]({ commit }) {
			commit(RESET_STATE);
		},
	},

	getters: {
		[ContactGetterKeys.loading]: state => Boolean(state.loading),
		[ContactGetterKeys.membersTableData]: state => state.membersTableData,
		[ContactGetterKeys.volunteersTableData]: state => state.volunteersTableData,
		[ContactGetterKeys.participantsTableData]: state =>
			state.participantsTableData,
		[ContactGetterKeys.jobParticipantsTableData]: state =>
			state.jobParticipantsTableData,
		[ContactGetterKeys.allContactsTableData]: state =>
			state.allContactsTableData,
		[ContactGetterKeys.applicationsTableData]: state =>
			state.applicationsTableData,
		[ContactGetterKeys.mergeContactsTableData]: state =>
			state.mergeContactsTableData,
		[ContactGetterKeys.partnerTableData]: state => state.partnerTableData,
		[ContactGetterKeys.allPartners]: state => state.allPartners,
		[ContactGetterKeys.allPartnersUnitMap]: state => state.allPartnersUnitMap,
		[ContactGetterKeys.contact]: state => state.contact,
		[ContactGetterKeys.contacts]: state => state.contacts,
		[ContactGetterKeys.selectedContacts]: state => state.selectedContacts,
		[ContactGetterKeys.contactPaymentStatuses]: state =>
			state.contactPaymentStatuses,
		[ContactGetterKeys.currentContactProfile]: state =>
			state.currentContactProfile || null,
		[ContactGetterKeys.currentMembershipApplication]: state =>
			state.currentMembershipApplication || null,
		[ContactGetterKeys.draftContactProfileStatus]: state =>
			state.draftContactProfileStatus || null,
		[ContactGetterKeys.draftContactProfilePaymentStatus]: state =>
			state.draftContactProfilePaymentStatus || null,
		[ContactGetterKeys.profileCenters]: state => state.profileCenters,
		[ContactGetterKeys.profileUsers]: state => state.profileUsers,
		[ContactGetterKeys.anythingEditing]: state => Boolean(state.editingItem),
		[ContactGetterKeys.contactEditing]: state =>
			state.editingItem === ContactEditableItem.contact,
		[ContactGetterKeys.contactProfileEditing]: state =>
			state.editingItem === ContactEditableItem.contactProfile,
		[ContactGetterKeys.newContactProfileEditing]: state =>
			state.editingItem === ContactEditableItem.newContactProfile,
		[ContactGetterKeys.contactRemarksEditing]: state =>
			state.editingItem === ContactEditableItem.contactRemarks,
		[ContactGetterKeys.familyContactsEditing]: state =>
			state.editingItem === ContactEditableItem.familyContacts,
		[ContactGetterKeys.familyContactEditing]: state =>
			state.editingItem === ContactEditableItem.familyContact,
		[ContactGetterKeys.membershipRenewing]: state =>
			state.editingItem === ContactEditableItem.membershipRenew,
		[ContactGetterKeys.familyMembersEditing]: state =>
			state.editingItem === ContactEditableItem.familyMembers,
		[ContactGetterKeys.newFamilyMemberEditing]: state =>
			state.editingItem === ContactEditableItem.newFamilyMember,
		[ContactGetterKeys.profileTypes]: state => state.profileTypes,
		[ContactGetterKeys.getProfileTypesByContactType]: state => (
			contactType: ContactTypeCode,
		): ProfileType[] => {
			state.profileTypes.filter(profileType => {
				return profileType.contactType === contactType;
			});
			return state.profileTypes.filter(
				profileType => profileType.contactType === contactType,
			);
		},
		[ContactGetterKeys.contactProfiles]: state =>
			state.contact?.contactProfiles || [],
		[ContactGetterKeys.caseNotes]: state => state.caseNotes,
		[ContactGetterKeys.contactProfilesGroupedByContactType]: (
			_,
			getters,
		): GroupedContactProfiles[] => {
			const groupedContactProfiles: Map<
				ContactProfileGroup,
				ContactProfile[]
			> = new Map();
			for (const profile of getters.contactProfiles as ContactProfile[]) {
				const group: ContactProfileGroup =
					profile.type === ContactTypeCode.participant ||
					profile.type === ContactTypeCode.jobParticipant
						? ContactProfileGroup.activity
						: profile.type;

				groupedContactProfiles.set(group, [
					...(groupedContactProfiles.get(group) ?? []),
					profile,
				]);
			}

			const subgrouped = (profiles: ContactProfile[]) => {
				const groupedProfiles: SubgroupedContactProfiles[] = [];
				profiles
					.sort((profileA, profileB) =>
						profileA.type === ContactTypeCode.jobParticipant
							? -1
							: profileB.type === ContactTypeCode.jobParticipant
							? 1
							: 0,
					)
					.forEach(profile => {
						// group family and activity

						const isActivity = [
							ContactTypeCode.participant,
							ContactTypeCode.jobParticipant,
						].includes(profile.type);

						/* Prefer profileType.id so distinct profile types never merge (e.g. all family
						 * categories used to share subgroupKey "family" and showed one tab label). */
						const subgroupKey = isActivity
							? ContactProfileGroup.activity
							: profile.profileType?.id != null
								? `profileType:${profile.profileType.id}`
								: profile.profileType?.category ===
									  ProfileTypeCategoryCode.family
									? profile.profileType.category
									: profile.profileType?.code ?? profile.type ?? '';

						let existingGroup = groupedProfiles.find(
							groupedProfile => groupedProfile.subgroupKey === subgroupKey,
						);
						if (!existingGroup) {
							existingGroup = {
								subgroupKey,
								profiles: [],
							};
							groupedProfiles.push(existingGroup);
						}
						existingGroup.profiles.push(profile);
					});
				return groupedProfiles;
			};

			const groups: GroupedContactProfiles[] = [];
			groupedContactProfiles.forEach((profiles, groupKey) => {
				groups.push({
					groupKey,
					subgroupedContactProfiles: subgrouped(profiles),
				});
			});

			groups.sort((groupA, groupB) => {
				// put activity the first
				if (groupA.groupKey === ContactProfileGroup.activity) return -1;
				if (groupB.groupKey === ContactProfileGroup.activity) return 1;
				return 0;
			});

			groups.sort((groupA, groupB) => {
				// put case the last
				if (groupA.groupKey === ContactProfileGroup.case) return 1;
				if (groupB.groupKey === ContactProfileGroup.case) return -1;
				return 0;
			});

			return groups;
		},

		[ContactGetterKeys.getContactProfileById]: (state, getters) => (
			profileId: number,
		) =>
			getters.contactProfiles.find(
				(profile: ContactProfile) => profile.id === profileId,
			) || null,
		[ContactGetterKeys.currentContactType]: state => state.currentContactType,
		[ContactGetterKeys.currentProfileType]: state => state.currentProfileType,
		[ContactGetterKeys.mainFamilyMember]: state =>
			state.familyMemberProfiles?.find(
				profile => profile.familyApplicantType === FamilyApplicantType.main,
			),
		[ContactGetterKeys.getFamilyRelationsByContact]: state => (
			contactId: number,
		): FamilyRelation[] => state.familyRelationsByContact[contactId] || [],
		[ContactGetterKeys.familyMembers]: (
			state,
			getters,
		): { profile: ContactProfile; relation?: RelationCode }[] => {
			const familyRelations: FamilyRelation[] = getters.getFamilyRelationsByContact(
				getters.mainFamilyMember?.contactId,
			);
			return state.familyMemberProfiles
				.map(profile => {
					const relation: FamilyRelation | undefined = familyRelations.find(
						(relation: FamilyRelation) =>
							relation.relatedContactId === profile.contactId,
					);
					return {
						profile: {
							...profile,
							contact:
								profile.familyApplicantType === FamilyApplicantType.main
									? state.contacts.find(
											contact => contact.id === profile.contactId,
									  )
									: relation?.relatedContact,
						},
						relation:
							profile.familyApplicantType === FamilyApplicantType.main
								? 'mainApplicant'
								: relation?.relation,
					};
				})
				.sort(
					// main applicant always comes first
					(memberA, memberB) =>
						memberA.profile.familyApplicantType === FamilyApplicantType.main
							? -1
							: memberB.profile.familyApplicantType === FamilyApplicantType.main
							? 1
							: 0,
				);
		},
		[ContactGetterKeys.allFamilyProfilesAllMembers]: state =>
			state.allFamilyProfilesAllMembers,
		[ContactGetterKeys.currentCenter]: state => state.currentCenter,
		[ContactGetterKeys.duplicateContactCandidates]: state =>
			state.duplicateContactChecking.contacts,
		[ContactGetterKeys.getDuplicateFamilyContactCandidates]: state => (
			index: number,
		) => state.duplicateFamilyContactCheckings[index]?.contacts || [],
		[ContactGetterKeys.draftContact]: state => state.draftContact,
		[ContactGetterKeys.draftFamilyMembers]: state => state.draftFamilyMembers,
		[ContactGetterKeys.draftFamilyContactsWithRelations]: state =>
			state.draftFamilyContactsWithRelations,
		[ContactGetterKeys.getDraftFamilyMemberByKey]: state => (key: number) =>
			state.draftFamilyMembers[key] || null,
		[ContactGetterKeys.familyRelations]: state => state.familyRelations,
		[ContactGetterKeys.applicationsForContacts]: state =>
			state.applicationsForContacts,
		[ContactGetterKeys.searchMergeContactBy]: state =>
			state.searchMergeContactBy,
		[ContactGetterKeys.searchMergeContactInput]: state =>
			state.searchMergeContactInput,
		[ContactGetterKeys.mergeTargetContact]: state => state.mergeTargetContact,
		[ContactGetterKeys.connectInvite]: state => state.connectInvite,
		[ContactGetterKeys.contactSearchResult]: state => state.contactSearchResult,
		[ContactGetterKeys.currentContact]: state => state.currentContact,
		[ContactGetterKeys.ngosForPartership]: state => state.ngosForPartership,
		[ContactGetterKeys.caseProfileDialogOpen]: state =>
			state.caseProfileDialogOpen,
		[ContactGetterKeys.donationProfileDialogOpen]: state =>
			state.donationProfileDialogOpen,
	},
};

export default store;
